import { Suspense, lazy } from 'react';

const Component = lazy(() => import("./Chooser"));

function IPWhitelistMgr() {

  return (
    <div>
      <Suspense fallback={<div>loading...</div>}>
        <Component />
      </Suspense>
    </div>);

}

export default IPWhitelistMgr;

